"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@chakra-ui/core");
const ContentContainer = ({ children }) => {
    return (react_1.default.createElement(core_1.Box, { maxW: "6xl", mx: "auto", px: { base: 4, sm: 6, lg: 8 } }, children));
};
exports.default = ContentContainer;
